import { jsx as m } from "react/jsx-runtime";
import d from "classnames";
import { forwardRef as k } from "react";
import E from "./index.es822.js";
import { useSkeleton as S } from "./index.es823.js";
import { mergeRefs as n } from "./index.es551.js";
const T = "skeleton", _ = k(
  ({
    children: e,
    isVisible: t,
    height: o,
    width: f,
    margin: i,
    borderRadius: l,
    testId: p = T,
    ...r
  }, s) => {
    const { ref: a, sizing: c } = S({
      isVisible: t,
      height: o,
      width: f,
      borderRadius: l
    }), u = d(E["skeleton-container"]), y = {
      ...c,
      margin: i
    };
    return t ? /* @__PURE__ */ m(
      "div",
      {
        className: u,
        "aria-busy": !0,
        role: "status",
        "aria-live": "polite",
        ref: n(s, a),
        style: y,
        "data-testid": p,
        ...r,
        children: e
      }
    ) : /* @__PURE__ */ m("div", { ref: n(s, a), ...r, style: { height: o }, children: e });
  }
);
export {
  T as SKELETON_DEFAULT_TESTID,
  _ as Skeleton
};
//# sourceMappingURL=index.es71.js.map
